import { onResetPasswordEvent as z, onResetPasswordFailedEvent as j, onRestorePasswordEvent as N, onRegisterEvent as O, onRegisterFailedEvent as W, onAuthEvent as B, onLoginEvent as Q, onLoginFailedEvent as $, onLogoutEvent as M, removeResetPasswordEvent as G, removeResetPasswordFailedEvent as J, removeRestorePasswordEvent as K, removeRegisterEvent as X, removeRegisterFailedEvent as Y, removeAuthEvent as Z, removeLoginEvent as A, removeLoginFailedEvent as ee, removeLogoutEvent as te, onIncreaseCartItemEvent as ne, onDecreaseCartItemEvent as re, onViewCartEvent as oe, removeIncreaseCartItemEvent as ae, removeDecreaseCartItemEvent as S, removeViewCartEvent as se, onBeginCheckoutEvent as ie, onAddPaymentInfoEvent as ue, onAddShippingInfoEvent as ce, onPurchaseEvent as ve, removeBeginCheckoutEvent as de, removeAddPaymentInfoEvent as me, removeAddShippingInfoEvent as le, removePurchaseEvent as _e, onApplyListFiltersEvent as ge, removeApplyListFiltersEvent as he, onLoginLinkRequested as pe, removeLoginLinkRequested as Ee, onUserRegistered as we, removeUserRegistered as fe, onStartReturnEvent as ke, onErrorReturnEvent as ye, onOrderReturnEvent as Ce, onShowQrCodeReturnEvent as Re, onSaveQrCodeReturnEvent as Se, onSaveReturnLabelEvent as Pe, removeStartReturnEvent as Te, removeErrorReturnEvent as be, removeOrderReturnEvent as Le, removeShowQrCodeReturnEvent as qe, removeSaveQrCodeReturnEvent as Ie, removeSaveReturnLabelEvent as xe, onNoSearchResultEvent as Ue, removeNoSearchResultEvent as Fe, onShoeSizeFinderEvent as He, removeShoeSizeFinderEvent as De, onViewProductDetailEvent as Ve, removeViewProductDetailEvent as ze, onVirtualPageViewEvent as je, removeVirtualPageViewEvent as Ne, onAddWishlistItemEvent as Oe, onRemoveWishlistItemEvent as We, removeAddWishlistItemEvent as Be, removeRemoveWishlistItemEvent as Qe } from "@fond-of/event";
import { getCurrentLocale as $e } from "@fond-of/locale";
const Me = {
  /**
   * Generates a unique identifier to use
   * as class for tracking purpose
   */
  getTrackingDataAttributes: (e) => ({
    "data-cs-track": e
  })
};
/*! js-cookie v3.0.5 | MIT */
function w(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var a in r)
      e[a] = r[a];
  }
  return e;
}
var Ge = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function y(e, t) {
  function r(n, i, s) {
    if (!(typeof document > "u")) {
      s = w({}, t, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), n = encodeURIComponent(n).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var o = "";
      for (var c in s)
        s[c] && (o += "; " + c, s[c] !== !0 && (o += "=" + s[c].split(";")[0]));
      return document.cookie = n + "=" + e.write(i, n) + o;
    }
  }
  function a(n) {
    if (!(typeof document > "u" || arguments.length && !n)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], s = {}, o = 0; o < i.length; o++) {
        var c = i[o].split("="), m = c.slice(1).join("=");
        try {
          var u = decodeURIComponent(c[0]);
          if (s[u] = e.read(m, u), n === u)
            break;
        } catch {
        }
      }
      return n ? s[n] : s;
    }
  }
  return Object.create(
    {
      set: r,
      get: a,
      remove: function(n, i) {
        r(
          n,
          "",
          w({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(n) {
        return y(this.converter, w({}, this.attributes, n));
      },
      withConverter: function(n) {
        return y(w({}, this.converter, n), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var Je = y(Ge, { path: "/" });
const Ke = () => Je.get("fondof_internal") === "true", Xe = (e) => {
  const t = z(({ source: u }) => {
    e.event({
      event: "reset_password_requested",
      method: u
    });
  }), r = j(({ source: u }) => {
    e.event({
      event: "reset_password_requested",
      method: u
    });
  }), a = N(
    async ({ email: u, source: v }) => {
      await e.user(u), e.event({
        event: "restore_password",
        method: v
      }), e.event({
        event: "login",
        method: v
      });
    }
  ), n = O(async ({ email: u, source: v }) => {
    await e.user(u), e.event({
      event: "sign_up_requested",
      method: v
    }), e.event({
      event: "sign_up",
      method: v
    });
  }), i = W(({ source: u }) => {
    e.event({
      event: "sign_up_requested",
      method: u
    });
  }), s = B(async ({ isLoggedIn: u, customer: v }) => {
    u && await e.user(v.email);
  }), o = Q(async ({ customer: u, source: v }) => {
    await e.user(u.email), e.event({
      event: "login_requested",
      method: v
    }), e.event({
      event: "login",
      method: v
    });
  }), c = $(({ source: u }) => {
    e.event({
      event: "login_requested",
      method: u
    });
  }), m = M(() => {
    e.event({
      event: "logout"
    });
  });
  return () => {
    G(t), J(r), K(a), X(n), Y(i), Z(s), A(o), ee(c), te(m);
  };
}, d = (e) => e / 100, C = (e) => ({
  item_id: e.sku,
  item_brand: e.concreteProducts[0].attributes.brand,
  price: d(
    e.concreteProducts[0].concreteProductPrices[0].price
  ),
  item_name: e.concreteProducts[0].attributes.model_untranslated,
  item_variant: e.concreteProducts[0].attributes.style_untranslated,
  dimension_10: e.concreteProducts[0].attributes.size,
  quantity: e.quantity
}), p = (e) => {
  var t;
  return ((t = e.cartItems) == null ? void 0 : t.map((r) => C(r))) || [];
}, k = (e) => e.map((t) => {
  var r;
  return {
    id: t.sku,
    name: (r = t.concreteProducts) == null ? void 0 : r[0].attributes.name_untranslated,
    price: d(t.calculations.unitPriceToPayAggregation),
    priceexcludingtax: d(
      t.calculations.unitPriceToPayAggregation - t.calculations.unitTaxAmountFullAggregation
    ),
    quantity: t.quantity,
    sku: t.sku,
    tax: d(t.calculations.unitTaxAmountFullAggregation),
    taxrate: t.calculations.taxRate
  };
}), P = (e) => ({
  item_id: e.sku,
  item_brand: e.attributes.brand,
  price: d(e.price),
  item_name: String(e.attributes.modelUntranslated),
  item_variant: e.attributes.styleUntranslated,
  dimension_10: e.attributes.size,
  quantity: 1
}), Ye = (e) => {
  const t = ne(
    ({ cartItem: n, quantity: i, cart: s }) => {
      e.event({
        ecommerce_ga4: null
      }), e.event({
        event: "add_to_cart",
        ecommerce_ga4: {
          items: [{ ...C(n), quantity: i }]
        },
        transactionProducts: k(s.cartItems),
        subtotal: d(s.totals.subtotal),
        currency: s.currency
      });
    }
  ), r = re(
    ({ cartItem: n, quantity: i, cart: s }) => {
      e.event({
        ecommerce_ga4: null
      }), e.event({
        event: "remove_from_cart",
        ecommerce_ga4: {
          items: [{ ...C(n), quantity: i * -1 }]
        },
        transactionProducts: k(s.cartItems),
        subtotal: d(s.totals.subtotal),
        currency: s.currency
      });
    }
  ), a = oe(({ cart: n }) => {
    e.event({
      ecommerce_ga4: null
    }), e.event({
      event: "view_cart",
      ecommerce_ga4: {
        items: p(n)
      },
      transactionProducts: k(n.cartItems),
      subtotal: d(n.totals.subtotal),
      currency: n.currency
    });
  });
  return () => {
    ae(t), S(r), S(r), se(a);
  };
}, l = async (e, t = "SHA-1") => {
  var i;
  const r = await ((i = crypto.subtle) == null ? void 0 : i.digest(
    t,
    Ze(Ae(e))
  ));
  return Array.from(new Uint8Array(r)).map((s) => s.toString(16).padStart(2, "0")).join("");
}, Ze = (e) => new TextEncoder().encode(e), Ae = (e) => e.toLowerCase(), et = (e) => {
  const t = ie(({ cart: i }) => {
    e.event({
      ecommerce_ga4: null
    }), e.event({
      event: "begin_checkout",
      ecommerce_ga4: {
        items: p(i)
      }
    });
  }), r = ue(
    ({ cart: i, paymentMethod: s }) => {
      e.event({
        ecommerce_ga4: null
      }), e.event({
        event: "add_payment_info",
        ecommerce_ga4: {
          payment_type: s,
          items: p(i)
        }
      });
    }
  ), a = ce(({ cart: i }) => {
    e.event({
      ecommerce_ga4: null
    }), e.event({
      event: "add_shipping_info",
      ecommerce_ga4: {
        items: p(i)
      }
    });
  }), n = ve(
    async ({ cart: i, orderReference: s, billingAddress: o, language: c }) => {
      var m;
      o.email && e.event({
        event: "setUserId",
        externalIdHash: await l(o.email),
        // hier kann auch userId verwendet werden
        userId: await l(o.email),
        userIdv2: await l(o.email, "SHA-256"),
        email: o.email,
        firstName: o.firstName,
        firstNameHash: await l(
          o.firstName,
          "SHA-256"
        ),
        lastName: o.lastName,
        lastNameHash: await l(o.lastName, "SHA-256"),
        ...o.phone && {
          phone: o.phone.replace(/\D/g, ""),
          phoneHash: await l(
            o.phone.replace(/\D/g, ""),
            "SHA-256"
          )
        },
        addressLine1: o.address1,
        addressLine2: o.address3,
        zipCode: o.zipCode,
        zipCodeHash: await l(o.zipCode, "SHA-256"),
        city: o.city,
        cityHash: await l(o.city, "SHA-256"),
        country: o.iso2Code,
        countryHash: await l(o.iso2Code, "SHA-256"),
        language: c,
        languageHash: await l(c, "SHA-256")
      }), e.event({
        ecommerce_ga4: null
      }), e.event({
        event: "purchase",
        transactionProductsSkus: [
          ...new Set(i.cartItems.map((u) => u.sku))
        ],
        ecommerce_ga4: {
          transaction_id: s,
          value: d(i.totals.grandTotal),
          tax: d(i.totals.taxTotal),
          shipping: d(i.totals.shipmentTotal),
          currency: i.currency,
          coupon: ((m = i.discounts[0]) == null ? void 0 : m.code) || null,
          items: p(i)
        }
      }), e.event({
        event: "tt_order",
        tt_content: JSON.stringify(
          i.cartItems.map((u) => ({
            content_id: u.sku,
            content_name: u.concreteProducts[0].attributes.model_untranslated,
            content_category: u.concreteProducts[0].attributes.style_untranslated,
            brand: u.concreteProducts[0].attributes.brand,
            quantity: u.quantity,
            price: d(
              u.concreteProducts[0].concreteProductPrices[0].price
            )
          }))
        )
      });
    }
  );
  return () => {
    de(t), me(r), le(a), _e(n);
  };
}, tt = (e) => {
  const t = ge(({ listFilters: r }) => {
    for (const [a, n] of Object.entries(r))
      n && n.length && e.event({
        event: `item_list_filter_${a}`,
        item_list_filter_selection: typeof n == "string" ? n : n.toString()
      });
  });
  return () => {
    he(t);
  };
}, nt = (e) => {
  const t = pe(({ source: r }) => {
    const a = r ? `login_link_requested_${r.toLowerCase()}` : "login_link_requested";
    e.event({
      event: a
    });
  });
  return () => {
    Ee(t);
  };
}, rt = (e) => {
  const t = we(({ email: r, source: a }) => {
    const n = a ? `user_registered_${a.toLowerCase()}` : "user_registered";
    e.event({
      event: n,
      email: r
    });
  });
  return () => {
    fe(t);
  };
}, ot = (e) => {
  const t = ke(() => {
    e.event({
      event: "returns_tracking",
      returns_action: "return start",
      product_sku: "",
      item_name: "",
      item_variant: "",
      returns_country: ""
    });
  }), r = ye(({ error: o }) => {
    e.event({
      event: "returns_tracking",
      returns_action: "error",
      returns_label: o,
      product_sku: "",
      item_name: "",
      item_variant: "",
      returns_country: ""
    });
  }), a = Ce(
    ({ order: o, selectedProducts: c, selectedAddress: m }) => {
      var u, v;
      for (const { sku: g, reason: h } of c) {
        const _ = o.items.find((f) => f.sku === g);
        e.event({
          event: "returns_tracking",
          returns_action: "return product",
          product_sku: g,
          item_name: ((u = _ == null ? void 0 : _.product) == null ? void 0 : u.attributes.modelUntranslated) || "",
          item_variant: ((v = _ == null ? void 0 : _.product) == null ? void 0 : v.attributes.styleUntranslated) || "",
          returns_label: h,
          returns_country: o[m].iso2Code
        });
      }
    }
  ), n = Re(
    ({ order: o, addressType: c }) => {
      e.event({
        event: "returns_tracking",
        returns_action: "returns download",
        returns_label: "show qr code",
        product_sku: "",
        item_name: "",
        item_variant: "",
        returns_country: o[c].iso2Code
      });
    }
  ), i = Se(
    ({ order: o, addressType: c }) => {
      e.event({
        event: "returns_tracking",
        returns_action: "returns download",
        returns_label: "save qr code",
        product_sku: "",
        item_name: "",
        item_variant: "",
        returns_country: o[c].iso2Code
      });
    }
  ), s = Pe(
    ({ order: o, addressType: c }) => {
      e.event({
        event: "returns_tracking",
        returns_action: "returns download",
        returns_label: "download pdf label",
        product_sku: "",
        item_name: "",
        item_variant: "",
        returns_country: o[c].iso2Code
      });
    }
  );
  return () => {
    Te(t), be(r), Le(a), qe(n), Ie(i), xe(s);
  };
}, at = (e) => {
  const t = Ue(({ searchTerm: r }) => {
    r && e.event({
      event: "no_search_result",
      search_term: r
    });
  });
  return () => {
    Fe(t);
  };
}, st = (e) => {
  const t = He(({ action: r, label: a }) => {
    e.event({
      event: "shoe_size_finder",
      action: r,
      label: a
    });
  });
  return () => {
    De(t);
  };
}, it = (e) => {
  const t = Ve(
    ({ product: r }) => {
      e.event({
        ecommerce_ga4: {
          items: [
            {
              dimension_10: r.attributes.size,
              item_brand: r.attributes.brand,
              item_id: r.sku,
              item_name: r.attributes.modelUntranslated || "",
              item_variant: r.attributes.styleUntranslated,
              price: r.price / 100
            }
          ]
        },
        event: "view_item"
      });
    }
  );
  return () => {
    ze(t);
  };
}, ut = (e) => {
  const t = je(
    ({
      url: r,
      pageType: a,
      version: n,
      currency: i,
      customerEmail: s,
      internalTraffic: o,
      store: c,
      system: m,
      transactionAffiliation: u,
      transactionCurrency: v,
      transactionPayment: g,
      transactionDate: h,
      transactionEntity: _,
      transactionTax: f,
      transactionId: L,
      transactionProducts: E,
      transactionProductsSkus: q,
      transactionShipping: I,
      transactionSubtotal: x,
      transactionTotal: U,
      transactionTotalWithoutShippingAmount: F,
      voucherCode: H
    }) => {
      e.event({
        event: "vpv_general",
        vpv_url: r,
        pageType: a,
        version: n,
        currency: i,
        customerEmail: s,
        internalTraffic: o,
        store: c,
        system: m,
        transactionAffiliation: u,
        transactionCurrency: v,
        transactionPayment: g,
        transactionDate: h,
        transactionEntity: _,
        transactionTax: f,
        transactionId: L,
        transactionProducts: E || [],
        transactionProductsSkus: q || [],
        transactionProductsQuantity: (E == null ? void 0 : E.reduce(
          (D, V) => D += V.quantity,
          0
        )) || 0,
        transactionShipping: I,
        transactionSubtotal: x,
        transactionTotal: U,
        transactionTotalWithoutShippingAmount: F,
        voucherCode: H
      });
    }
  );
  return () => {
    Ne(t);
  };
}, ct = (e) => {
  const t = Oe(({ wishlistItem: a }) => {
    e.event({
      ecommerce_ga4: null
    }), e.event({
      event: "add_to_wishlist",
      ecommerce_ga4: {
        items: [P(a)],
        currency: a.currency.code,
        value: d(a.price)
      }
    });
  }), r = We(
    ({ wishlistItem: a }) => {
      e.event({
        ecommerce_ga4: null
      }), e.event({
        event: "remove_from_wishlist",
        ecommerce_ga4: {
          items: [P(a)],
          currency: a.currency.code,
          value: d(a.price)
        }
      });
    }
  );
  return () => {
    Be(t), Qe(r);
  };
}, R = (e) => {
  const t = document.createElement("script");
  if (t.type = "text/javascript", t.async = !0, e(t), !document.querySelector(`script[src="${t.src}"]`))
    return document.head.appendChild(t), t;
}, vt = (e) => R((t) => {
  t.src = `https://www.googletagmanager.com/gtm.js?id=${e}`, t.onload = () => {
    window.dataLayer.push({
      event: "gtm.js",
      "gtm.start": (/* @__PURE__ */ new Date()).getTime(),
      "gtm.uniqueEventId": 0
    });
  };
}), dt = (e, t, r, a) => {
  r && (window.UC_UI_DOMAINS = {
    crossDomainConsentSharingIFrame: r
  }), R((n) => {
    n.id = "usercentrics-cmp", n.src = "https://app.usercentrics.eu/browser-ui/latest/loader.js", n.setAttribute("data-settings-id", e), n.setAttribute("data-language", $e()), t && n.setAttribute("data-ruleset-id", t);
  }), R((n) => {
    n.type = "application/javascript", n.src = "https://privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js", n.async = !1, n.onload = () => {
      typeof window.uc < "u" && a && window.uc.setServiceAlias(a.serviceAliases || {});
    };
  });
}, mt = (e) => e.charAt(0).toUpperCase() + e.slice(1), T = () => !!window.dataLayer.find((e) => e.event === "gtm.load"), lt = {
  /**
   * Save all called dataLayer pushes before gtm got loaded
   */
  events: [],
  /**
   * Accepts custom event and tracks
   * its value in the dataLayer
   */
  event(e) {
    if (typeof e == "string") {
      this.push({
        event: e
      });
      return;
    }
    this.push(e);
  },
  /**
   * Accepts a custom page type and tracks
   * its value in the dataLayer
   * @param {string} pageType - The type of the page
   */
  page(e) {
    this.push({
      pageType: e
    });
  },
  /**
   * TODO: Discuss if identifier should be more randomized
   *
   * Generates a unique identifier to use
   * as class for tracking purpose
   * @param {string} type - The type of the identifier
   * @param {string} identifier - The identifier
   * @returns {string} - The unique identifier
   */
  getUniqueId: (e, t) => `gtm${mt(e)}-${t}`,
  /**
   * Generates a SHA1 and SHA256 user ID and tracks
   * the user in the dataLayer
   * @param {string} email - The email address of the user
   */
  async user(e) {
    const [t, r] = await Promise.all([
      l(e),
      l(e, "SHA-256")
    ]);
    this.push({
      event: "setUserId",
      externalIdHash: t,
      userId: t,
      userIdv2: r
    });
  },
  loadEvents() {
    const e = setInterval(() => {
      T() && (this.events.forEach((t) => window.dataLayer.push(t)), clearInterval(e));
    }, 500);
  },
  /**
   * Inits the dataLayer, usercentrics script, gtm script
   * and register the analytics events
   * @param {object} options - The options object
   * @returns void
   */
  init(e) {
    window.dataLayer = window.dataLayer || [];
    const t = (e == null ? void 0 : e.gtmId) && (e == null ? void 0 : e.usercentricsId);
    t && (window.dataLayer.push({
      internalTraffic: Ke(),
      ...e.initialDataLayer
    }), dt(
      e.usercentricsId,
      e.ucRulesetId,
      e.ucCrossDomainUrl,
      e.ucSdpSettings
    ), window.addEventListener("ucEvent", ({ detail: { type: _ } }) => {
      _ !== "implicit" && (vt(e.gtmId), this.loadEvents());
    })), t || this.loadEvents();
    const r = Ye(this), a = et(this), n = ct(this), i = ut(this), s = Xe(this), o = tt(this), c = st(this), m = nt(this), u = rt(this), v = ot(this), g = at(this), h = it(this);
    return () => {
      r(), a(), i(), s(), o(), m(), u(), v(), g(), c(), n(), h();
    };
  },
  /**
   * Accepts and event payload and either
   * writes to the dayalayer
   * @param {object} payload - The event payload
   */
  push(e) {
    if (!T()) {
      this.events.push(e);
      return;
    }
    window.dataLayer.push(e);
  }
}, _t = () => {
  window.addEventListener("ucEvent", (e) => {
    e.detail && e.detail.event === "consent_status" && e.detail.type === "explicit" && (window.uetq = window.uetq || [], window.uetq.push("consent", "update", {
      ad_storage: e.detail["Microsoft Advertising"] ? "granted" : "denied"
    }));
  });
}, gt = {
  init: () => {
    _t();
  }
}, ht = () => ({
  contentsquare: Me,
  google: lt,
  microsoftAdvertising: gt
}), b = ht(), wt = {
  mounted: (e, t) => {
    if (t.value === !1)
      return;
    const r = b.contentsquare.getTrackingDataAttributes(
      t.value
    );
    for (const [a, n] of Object.entries(r))
      e.setAttribute(a, n);
  },
  getSSRProps: (e) => {
    if (e.value !== !1)
      return b.contentsquare.getTrackingDataAttributes(e.value);
  }
};
export {
  ht as Analytics,
  b as default,
  wt as vTracking
};
//# sourceMappingURL=analytics.js.map
